import React from 'react';
import LegacyIconButton, { IconButtonProps } from './IconButton.legacy';
import AlphaIconButton from './IconButton.alpha';

const Component = process.env.IS_LEGACY ? LegacyIconButton : AlphaIconButton;
export default Component as React.FC<IconButtonProps>;
export type { IconButtonProps };
